const DOCUMENT_MASK_REGEX = /[./\-\s]/g;
const DOCUMENT_ALLOWED_CHARACTERS_REGEX = /[^A-Z0-9]/gi;

export function sanitizeDocument(value?: string | null): string {
  return String(value || '')
    .replace(DOCUMENT_MASK_REGEX, '')
    .replace(DOCUMENT_ALLOWED_CHARACTERS_REGEX, '')
    .trim()
    .toUpperCase();
}

export function hasLetterInDocument(value?: string | null): boolean {
  return /[A-Z]/i.test(sanitizeDocument(value));
}

export function isCompleteCpf(value?: string | null): boolean {
  return /^\d{11}$/.test(sanitizeDocument(value));
}

export function isCompleteCnpj(value?: string | null): boolean {
  return /^[A-Z0-9]{12}\d{2}$/i.test(sanitizeDocument(value));
}
